export default __webpack_public_path__ + "static/img-ei-10-cb5a8b2cc9beca6a038ab96b4708faaa.png";